/* ------------------------ Functionsl imports start ------------------------ */
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { IconButton } from '@mui/material'
import { type ColumnProps } from 'antd/es/table/Column'
import { useTranslation } from 'react-i18next'

import { getAddressRepresentation } from '../../../utils/functions'
import { type FormFieldType } from '../../Form'

/* ------------------------- Functional imports end ------------------------- */

type Props = {
  supplier?: string
  name:
    | 'supplierDetailsTableColumns'
    | 'supplierFormFields'
    | 'supplierVersionsFormFields'
    | 'supplierExpandedTableColumns'
    | 'supplierTableColumns'
}

/* -------------------------------------------------------------------------- */
/*                               Start Component                              */
/* -------------------------------------------------------------------------- */

export default function GetConstant(props: Props): FormFieldType[] | ColumnProps<any>[] {
  /* -------------------------- Non state data start -------------------------- */
  const { t } = useTranslation()
  /* --------------------------- Non state data end --------------------------- */

  if (props.name === 'supplierDetailsTableColumns') {
    return [
      {
        title: t('common:content.label.article'),
        dataIndex: 'name',
        key: 'name',
        render: (name: any) => name ?? '-',
      },
      {
        title: t('common:content.label.inStorage'),
        dataIndex: 'inStorage',
        key: 'inStorage',
        render: (inStorage: any) => inStorage ?? '-',
      },
    ]
  }
  if (props.name === 'supplierTableColumns') {
    return [
      {
        title: t('common:content.label.name'),
        dataIndex: 'name',
        key: 'name',
        render: (name: any) => name ?? '-',
      },
      {
        title: t('common:content.label.vat'),
        dataIndex: 'ustId',
        key: 'vat',
        render: (ustId: any) => ustId ?? '-',
      },
      {
        title: t('common:content.label.details'),
        key: '',
        render: () => (
          <IconButton>
            <InfoOutlinedIcon />
          </IconButton>
        ),
      },
    ]
  }
  if (props.name === 'supplierExpandedTableColumns') {
    return [
      {
        title: t('common:content.label.firstName'),
        dataIndex: 'firstName',
        key: 'firstName',
        render: (firstName: any) => firstName ?? '-',
      },
      {
        title: t('common:content.label.lastName'),
        dataIndex: 'lastName',
        key: 'lastName',
        render: (lastName: any) => lastName ?? '-',
      },
      {
        title: t('common:content.label.email'),
        dataIndex: 'email',
        key: 'email',
        render: (email: any) => email ?? '-',
      },
      {
        title: t('common:content.label.phone'),
        dataIndex: 'phone',
        key: 'phone',
        render: (phone: any) => phone ?? '-',
      },
      {
        title: t('common:content.label.address'),
        dataIndex: 'addresses',
        key: 'addresses',
        width: '30%',
        render: (addresses: any[]) =>
          addresses && addresses.length > 0 ? (
            <ul>
              {addresses.map((address: any, index: number) => (
                <li key={index}>{getAddressRepresentation(address)}</li>
              ))}
            </ul>
          ) : (
            '-'
          ),
      },
      {
        title: t('common:content.label.language'),
        dataIndex: 'language',
        key: 'language',
        render: (language: any) => language ?? '-',
      },
      {
        title: t('common:content.label.comment'),
        dataIndex: 'comment',
        key: 'comment',
        render: (comment: any) => comment ?? '-',
      },
    ]
  }
  if (props.name === 'supplierFormFields') {
    return [
      {
        type: 'text',
        key: 'name',
        label: t('common:content.label.name'),
        required: true,
        validation: true,
        xl: 12,
        lg: 12,
        md: 12,
        sm: 12,
        xs: 12,
      },
      {
        type: 'text',
        key: 'ustId',
        label: t('content.label.vat'),
        xl: 12,
        lg: 12,
        md: 12,
        sm: 12,
        xs: 12,
      },
    ] as FormFieldType[]
  }

  return [] as FormFieldType[]
}
